export default "__VITE_ASSET__HCH$12Fk__"